<template>
  <v-card class="pa-6">
    <v-card-title class="text-uppercase justify-space-between">
      Servicios Pawer relacionados
      <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <hr class="my-3" />
    <v-card-text>
      <div class="text-caption grey--text mb-1">Servicio de la clínica</div>
      <div class="text-body-2 font-weight-medium mb-4">{{ service.title }}</div>

      <div class="text-caption grey--text mb-1">Vinculados actualmente</div>
      <div v-if="!pawerServices.length" class="grey--text mb-4">
        Este servicio no tiene servicios Pawer vinculados — es un servicio propio.
      </div>
      <div class="mb-4">
        <v-chip
          v-for="ps in pawerServices"
          :key="ps.id"
          class="mr-2 mb-2"
          close
          :close-icon="'mdi-close'"
          :disabled="unlinkingId === ps.id"
          @click:close="removeLink(ps)"
        >
          {{ ps.title }}
        </v-chip>
      </div>

      <hr class="my-4" />

      <div class="text-caption grey--text mb-1">Vincular un servicio Pawer adicional</div>
      <v-row class="my-1" align="center">
        <v-col cols="8">
          <v-autocomplete
            label="Servicio del catálogo Pawer"
            v-model="serviceToLink"
            :items="linkableServices"
            :loading="loadingCatalogServices"
            item-text="title"
            item-value="id"
            outlined
            dense
            hide-details="auto"
          ></v-autocomplete>
        </v-col>
        <v-col cols="4">
          <v-btn
            color="primary"
            class="square-btn"
            small
            block
            :disabled="!serviceToLink || linking"
            :loading="linking"
            @click="addLink"
          >
            + Agregar
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <hr class="my-3" />
    <v-card-actions class="justify-end">
      <v-btn color="primary" rounded @click="closeDialog">Cerrar</v-btn>
    </v-card-actions>

    <v-snackbar v-model="showSnackbar" :timeout="5000" :color="snackbarColor">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showSnackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import ClinicsService from '../services/clinics.service';
import ServicesService from '../services/services.service';
import { utilsMixin } from '../mixins/utilsMixin';

export default {
  name: 'EditClinicServiceLinksModal',

  mixins: [utilsMixin],

  props: {
    clinicId: { type: String, required: true },
    service: { type: Object, required: true }
  },

  data() {
    return {
      pawerServices: [...this.service.pawerServices],
      unlinkingId: null,
      catalogServices: [],
      loadingCatalogServices: false,
      serviceToLink: null,
      linking: false,
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: ''
    };
  },

  computed: {
    // El backend no es idempotente en el vínculo (409 si ya existe) — se filtran del
    // dropdown los servicios ya vinculados para no ofrecer un vínculo que va a fallar.
    linkableServices() {
      const linkedIds = new Set(this.pawerServices.map(ps => ps.id));
      return this.catalogServices.filter(cs => !linkedIds.has(cs.id));
    }
  },

  mounted() {
    this.fetchCatalogServices();
  },

  methods: {
    async fetchCatalogServices() {
      this.loadingCatalogServices = true;
      const res = await ServicesService.getAllServices();
      if (res.status === 'ok') this.catalogServices = res.data;
      this.loadingCatalogServices = false;
    },

    closeDialog() {
      this.$emit('close-dialog');
    },

    async addLink() {
      if (!this.serviceToLink) return;

      this.linking = true;
      const res = await ClinicsService.linkClinicServicePawerService(
        this.clinicId,
        this.service.id,
        this.serviceToLink
      );
      this.linking = false;

      if (res.status === 'ok') {
        this.pawerServices = res.data.pawerServices;
        this.serviceToLink = null;
        this.$emit('update-list');
      } else if (res.httpCode === 409) {
        this.showErrorSnackbar('Ese servicio ya está vinculado a este clinic-service.');
      } else {
        this.showErrorSnackbar('No se pudo vincular ese servicio Pawer. Intenta nuevamente.');
      }
    },

    async removeLink(pawerService) {
      this.unlinkingId = pawerService.id;
      const res = await ClinicsService.unlinkClinicServicePawerService(
        this.clinicId,
        this.service.id,
        pawerService.id
      );
      this.unlinkingId = null;

      if (res.status === 'ok') {
        this.pawerServices = res.data.pawerServices;
        this.$emit('update-list');
      } else {
        this.showErrorSnackbar('No se pudo quitar el vínculo con ese servicio Pawer. Intenta nuevamente.');
      }
    }
  }
};
</script>

<style scoped>
.square-btn {
  border-radius: 8px !important;
}
</style>
